import React, { useState } from 'react';
import { Music, Heart, Folder, PlusCircle } from 'lucide-react';
import { mockPlaylists, mockSongs } from '../data/mockData';
import { useNavigate } from 'react-router-dom';
import { Play } from 'lucide-react';

const Library = ({ onPlaySong }) => {
  const [activeTab, setActiveTab] = useState('playlists');
  const navigate = useNavigate();

  const likedSongs = mockSongs.slice(0, 8);

  return (
    <div className="flex-1 overflow-y-auto pb-32 bg-gradient-to-br from-gray-50 via-white to-blue-50">
      <div className="p-8">
        <h1 className="text-5xl font-black text-gray-900 mb-8">Tu Biblioteca</h1>

        {/* Tabs */}
        <div className="flex gap-3 mb-8 border-b border-gray-200">
          <button
            onClick={() => setActiveTab('playlists')}
            className={`px-6 py-3 font-bold transition-all duration-300 flex items-center gap-2 ${
              activeTab === 'playlists'
                ? 'text-[#00CCFF] border-b-2 border-[#00CCFF]'
                : 'text-gray-500 hover:text-[#00CCFF]'
            }`}
          >
            <Folder size={22} />
            Playlists
          </button>
          <button
            onClick={() => setActiveTab('liked')}
            className={`px-6 py-3 font-bold transition-all duration-300 flex items-center gap-2 ${
              activeTab === 'liked'
                ? 'text-[#00CCFF] border-b-2 border-[#00CCFF]'
                : 'text-gray-500 hover:text-[#00CCFF]'
            }`}
          >
            <Heart size={22} />
            Me Gusta
          </button>
        </div>

        {/* Content */}
        {activeTab === 'playlists' && (
          <div>
            {/* Create Playlist Button */}
            <div
              onClick={() => navigate('/create-playlist')}
              className="bg-white p-6 rounded-2xl mb-8 cursor-pointer transition-all duration-300 flex items-center gap-4 group shadow-md hover:shadow-2xl transform hover:-translate-y-1"
            >
              <div className="w-20 h-20 bg-gradient-to-br from-[#00CCFF] to-[#056A84] rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <PlusCircle size={40} className="text-white" strokeWidth={3} />
              </div>
              <div>
                <h3 className="text-gray-900 font-black text-xl">Crear Playlist</h3>
                <p className="text-gray-500 text-sm font-medium">Organiza tu música cristiana</p>
              </div>
            </div>

            {/* Playlists Grid */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {mockPlaylists.map((playlist) => (
                <div
                  key={playlist.id}
                  onClick={() => navigate(`/playlist/${playlist.id}`)}
                  className="bg-white p-5 rounded-2xl transition-all duration-300 cursor-pointer group shadow-md hover:shadow-2xl transform hover:-translate-y-2"
                >
                  <div className="relative mb-4 overflow-hidden rounded-xl">
                    <img
                      src={playlist.cover}
                      alt={playlist.name}
                      className="w-full aspect-square object-cover transform transition-transform duration-500 group-hover:scale-110"
                    />
                    <button className="absolute bottom-3 right-3 w-14 h-14 bg-gradient-to-r from-[#00CCFF] to-[#056A84] rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 shadow-2xl hover:scale-110">
                      <Play size={22} className="text-white ml-0.5" fill="white" />
                    </button>
                  </div>
                  <h3 className="text-gray-900 font-bold mb-2 truncate text-lg">{playlist.name}</h3>
                  <p className="text-sm text-gray-500 line-clamp-2">{playlist.description}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'liked' && (
          <div>
            <div className="mb-8 bg-white p-6 rounded-2xl shadow-md">
              <h2 className="text-3xl font-black text-gray-900 mb-2">Canciones que te gustan</h2>
              <p className="text-gray-500 font-medium">{likedSongs.length} canciones</p>
            </div>

            <div className="space-y-2">
              {likedSongs.map((song, index) => (
                <div
                  key={song.id}
                  onClick={() => onPlaySong(song, likedSongs)}
                  className="flex items-center gap-4 p-4 rounded-xl hover:bg-white transition-all duration-300 cursor-pointer group shadow-sm hover:shadow-lg transform hover:-translate-y-1"
                >
                  <span className="text-gray-500 font-bold text-sm w-6">{index + 1}</span>
                  <img
                    src={song.cover}
                    alt={song.title}
                    className="w-16 h-16 rounded-xl object-cover shadow-md"
                  />
                  <div className="flex-1 min-w-0">
                    <h3 className="text-gray-900 font-bold truncate">{song.title}</h3>
                    <p className="text-sm text-gray-500 truncate">{song.artist}</p>
                  </div>
                  <span className="text-gray-500 text-sm font-medium">{song.duration}</span>
                  <button className="opacity-0 group-hover:opacity-100 transition-all duration-300 w-12 h-12 bg-gradient-to-r from-[#00CCFF] to-[#056A84] rounded-full flex items-center justify-center hover:scale-110 shadow-lg">
                    <Play size={18} className="text-white ml-0.5" fill="white" />
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Library;
